import { formatCompactRelativeTime, formatRelativeTime } from '@/lib/relative-time'

export function RelativeTime({ iso, compact = false, roundDown = false }: {
  iso: string
  compact?: boolean
  roundDown?: boolean
}) {
  const time = compact ? formatCompactRelativeTime(iso) : null
  return (
    <time dateTime={iso} title={new Date(iso).toLocaleString()} data-slot="relative-time">
      {time ? (
        <>
          <span aria-hidden="true">{time.short}</span>
          <span className="sr-only">{time.spoken}</span>
        </>
      ) : roundDown ? (
        formatCompactRelativeTime(iso).spoken
      ) : (
        formatRelativeTime(iso)
      )}
    </time>
  )
}
